<template>
  <div class="home_page" v-loading="reqLoading">
    <!-- 搜索组件 -->
    <CommonSearch @postSearchParams="postSearchParams"
    :needBoutiqueCategoryId="true"
    ref="commonSearchRef"
    pageName="premiumGoodCategoryList"></CommonSearch>
    <!-- 商品组件 -->
    <good-list
      :goodList="goodList"
      :page="page"
      :total="total"
      :premium="true"
      @refushDataList="refushDataList"
    >
    </good-list>
    <div class="no_show_message" v-show="!total">
      <img src="@/assets/img/good/noGood.png" :alt="$t('product.noGoods')" />
      <div>{{ $t('product.noGoods') }}</div>
    </div>
  </div>
</template>
<script>
// import backToTop from '@/components/back-to-top/index.vue'
import GoodList from './goodListScrollNew.vue'
import SelectedChild from './selectedChild.vue'
import CommonSearch from './commonSearch.vue'
export default {
  data () {
    return {
      reqLoading: false,
      goodList: [],
      page: 1,
      total: 0,
      searchParams: {}

    }
  },
  components: {
    GoodList,
    SelectedChild,
    CommonSearch
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    if (window.screen.width < 750) {
      this.jumpH5()
    }
  },
  methods: {
    jumpH5 () {
      let origin = window.location.origin
      origin = origin
        .replace('www.', 'm.')
        .replace('uat2-', 'uat2m-')
        .replace('pretest.', 'pretestm.')
        .replace('predev.', 'predevm.')
        .replace('uat.', 'uatm.')
      window.location.href = origin + '/#/pages/premium/index'
    },

    postSearchParams (params) {
      this.searchParams = params
      this.refushDataList(1)
    },
    // 查询商品列表及数据条数
    refushDataList (page = this.page, reset = true) {
      if (this.reqLoading) {
        return false
      }
      this.reqLoading = true
      this.page = page
      if (page === 1) {
        this.goodList = []
        this.total = 0
        // this.attributePage = 1
        this.$refs.commonSearchRef && this.$refs.commonSearchRef.setParams({
          attributePage: 1
        })
      }
      // /front/cross/commodity-user/web/spu-list 老spu列表接口
      this.$http
        .post(`/front/commodity-user/web/group-list`, {
          limit: 20,
          page: page,
          ...this.searchParams
        })
        .then(({ data: res }) => {
          this.reqLoading = false
          if (res.code !== 0) {
            this.goodList = []
            this.total = 0
            return false
          }
          if (reset) {
            this.goodList.push(...(res.data.dataList || []))
          } else {
            this.goodList = res.data.dataList || []
          }
          this.total = res.data.count
        })
        .catch(() => {
          this.reqLoading = false
          this.goodList = []
          this.total = 0
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
